import { createAction, props } from '@ngrx/store';

export const setSearchQuery = createAction('[UI] Set Search Query', props<{ query: string }>());
export const setNetworkStatus = createAction('[UI] Set Network Status', props<{ isOnline: boolean }>());
export const setSelectedTab = createAction('[UI] Set Selected Tab', props<{ tab: string }>());
export const showToast = createAction(
  '[UI] Show Toast',
  props<{ message: string; color?: string; duration?: number }>()
);
export const setLoading = createAction('[UI] Set Loading', props<{ key: string; loading: boolean }>());
